import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../../hooks/useAuth';

const PublicRoute = ({ children }) => {
	const { isAuthenticated } = useAuth();

	if (isAuthenticated) {
		return <Navigate to='/' replace />;
	}

	return children;
};

PublicRoute.propTypes = {
	children: PropTypes.node.isRequired,
};

export default PublicRoute;
